import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class DeviantRekenmoduleVoucherEndpointService {
  readonly #service = inject(ServicesService);

  getVoucher() {
    return this.#service.userService('deviant-rekenmodule/voucher');
  }
}
